import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReportsIcon from "@mui/icons-material/Unarchive";
import Divider from "@mui/material/Divider";
import AssignPrescriptionIcon from "@mui/icons-material/NoteAdd";
import { Link } from "@reach/router";
import USER_ROLES from "../common/userroles";
import { withTranslation } from "react-i18next";
import connectionType from "../common/connection-type";

const styles = (theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  textColor: {
    color: "black",
  },
  listItem: {
    "&.MuiButtonBase-root": {
      display: "flex",
      padding: "8px 24px 8px 24px",
    },
  },
});

class NestedList extends React.Component {
  state = {
    open: false,
    Dashboard: true,
    assignprescription: true,
    reports: true,
    assigneditemsreports: true,
    stockeditemsreports: true,
    cancelledItemsReports: true,
    pickedUpitemsreports: true,
    transactionsreports: true,
    enrolledPatientsreports: true,
    DeliveryTech: false,
    isIpayTransactionAllowed: true,
    isTemperatureMonitoringAllowed: true,
    isExpiredItemsAllowed: true,
    isSurveyReportAllowed: true,
    isConsultationReportAllowed: true,
    isScheduleConsultationAllowed: true,
    isOutForDeliveryAllowed: true,
    isDeliveredItemsAllowed: true,
    isLoyaltiMembersAllowed: true,
    isOrderStagingViewAllowed: true,
    isConsoleReportAllowed: true,
    payrollDeductionsreports: true,
    inActiveUsresAllowed: true,
    kioskUtilizationAllowed: true,
    tempatureHistoryAllowed: true,
    isPhiLogsVisible: false,
    isPurgeTrailVisible: false
  };
  handleClick = () => {
    this.setState((state) => ({ open: !state.open }));
  };
  componentDidMount() {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let _checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));
    if (_checkUserRole !== USER_ROLES.SUPERADMIN) {
      if (permissions && permissions.length > 0) {
        let permissionObj = {};
        permissions.map((item) => {
          return item.name === "Weekly Total"
            ? (permissionObj.weeklyTotal = true)
            : item.name === "Sales"
            ? (permissionObj.sales = true)
            : item.name === "Accounts"
            ? (permissionObj.accounts = true)
            : item.name === "Daily Sales States"
            ? (permissionObj.dailySalesStates = true)
            : item.name === "Consultations"
            ? (permissionObj.consultations = true)
            : item.name === "View"
            ? (permissionObj.view = true)
            : item.name === "Assign"
            ? (permissionObj.assign = true)
            : item.name === "UnAssign"
            ? (permissionObj.unAssign = true)
            : item.name === "Delete"
            ? (permissionObj.delete = true)
            : item.name === "Assigned Items"
            ? (permissionObj.assigned = true)
            : item.name === "Stocked Items"
            ? (permissionObj.stocked = true)
            : item.name === "Picked Up Items"
            ? (permissionObj.pickedUpItems = true)
            : item.name === "Transactions"
            ? (permissionObj.transactions = true)
            : item.name === "Cancelled Items"
            ? (permissionObj.cancelledItems = true)
            : null;
        });
        if (
          permissionObj.weeklyTotal &&
          permissionObj.sales &&
          permissionObj.accounts &&
          permissionObj.dailySalesStates &&
          permissionObj.consultations
        ) {
          this.setState({ Dashboard: true });
        } else {
          this.setState({ Dashboard: false });
        }

        if (
          permissionObj.view &&
          permissionObj.assign &&
          permissionObj.unAssign &&
          permissionObj.delete
        ) {
          this.setState({ assignprescription: true });
        } else {
          this.setState({ assignprescription: false });
        }

        if (
          permissionObj.assigned ||
          permissionObj.stocked ||
          permissionObj.pickedUpItems ||
          permissionObj.transactions
        ) {
          this.setState({ reports: true });
        } else {
          this.setState({ reports: false });
        }

        if (permissionObj.assigned) {
          this.setState({ assigneditemsreports: true });
        } else {
          this.setState({ assigneditemsreports: false });
        }
        if (permissionObj.stocked) {
          this.setState({ stockeditemsreports: true });
        } else {
          this.setState({ stockeditemsreports: false });
        }
        if (permissionObj.cancelledItems) {
          this.setState({ cancelledItemsReports: true });
        } else {
          this.setState({ cancelledItemsReports: false });
        }
        if (permissionObj.pickedUpItems) {
          this.setState({ pickedUpitemsreports: true });
        } else {
          this.setState({ pickedUpitemsreports: false });
        }
        if (permissionObj.transactions) {
          this.setState({ transactionsreports: true });
        } else {
          this.setState({ transactionsreports: false });
        }

        let permissionUser = JSON.parse(
          sessionStorage.getItem("permissionUser")
        );
        if (permissionUser === USER_ROLES.DELIVERYTECH) {
          this.setState({ DeliveryTech: true });
        }
      } else {
        this.setState({ Dashboard: false });
        this.setState({ assignprescription: false });
        this.setState({ reports: false });
      }
    }

    /** Report Permission Start Here */
    if (permissions && permissions.length > 0) {
      const iPayTransaction = permissions.filter((item) => {
        return item.name === "iPay Transactions";
      });
      if (iPayTransaction && iPayTransaction.length > 0) {
        this.setState({
          isIpayTransactionAllowed: iPayTransaction[0].is_allowed,
        });
      } else this.setState({ isIpayTransactionAllowed: false });
    } else this.setState({ isIpayTransactionAllowed: false });

    if (permissions && permissions.length > 0) {
      const temperatureMonitoring = permissions.filter((item) => {
        return item.name === "Temperature Monitoring";
      });
      if (temperatureMonitoring && temperatureMonitoring.length > 0) {
        this.setState({
          isTemperatureMonitoringAllowed: temperatureMonitoring[0].is_allowed,
        });
      } else this.setState({ isTemperatureMonitoringAllowed: false });
    } else this.setState({ isTemperatureMonitoringAllowed: false });

    if (permissions && permissions.length > 0) {
      const expiredItems = permissions.filter((item) => {
        return item.name === "Return to stock";
      });
      if (expiredItems && expiredItems.length > 0) {
        this.setState({ isExpiredItemsAllowed: expiredItems[0].is_allowed });
      } else this.setState({ isExpiredItemsAllowed: false });
    } else this.setState({ isExpiredItemsAllowed: false });

    if (permissions && permissions.length > 0) {
      const surveyReport = permissions.filter((item) => {
        return item.name === "Survey Report";
      });
      if (surveyReport && surveyReport.length > 0) {
        this.setState({ isSurveyReportAllowed: surveyReport[0].is_allowed });
      } else this.setState({ isSurveyReportAllowed: false });
    } else this.setState({ isSurveyReportAllowed: false });

    if (permissions && permissions.length > 0) {
      const consultationReport = permissions.filter((item) => {
        return item.name === "Consultation Report";
      });
      if (consultationReport && consultationReport.length > 0) {
        this.setState({
          isConsultationReportAllowed: consultationReport[0].is_allowed,
        });
      } else this.setState({ isConsultationReportAllowed: false });
    } else this.setState({ isConsultationReportAllowed: false });

    if (permissions && permissions.length > 0) {
      const scheduleConsultation = permissions.filter((item) => {
        return item.name === "Schedule Consultation";
      });
      if (scheduleConsultation && scheduleConsultation.length > 0) {
        this.setState({
          isScheduleConsultationAllowed: scheduleConsultation[0].is_allowed,
        });
      } else this.setState({ isScheduleConsultationAllowed: false });
    } else this.setState({ isScheduleConsultationAllowed: false });

    if (permissions && permissions.length > 0) {
      const outForDelivery = permissions.filter((item) => {
        return item.name === "Out for Delivery";
      });
      if (outForDelivery && outForDelivery.length > 0) {
        this.setState({
          isOutForDeliveryAllowed: outForDelivery[0].is_allowed,
        });
      } else this.setState({ isOutForDeliveryAllowed: false });
    } else this.setState({ isOutForDeliveryAllowed: false });

    if (permissions && permissions.length > 0) {
      const deliveredItems = permissions.filter((item) => {
        return item.name === "Delivered Items";
      });
      if (deliveredItems && deliveredItems.length > 0) {
        this.setState({
          isDeliveredItemsAllowed: deliveredItems[0].is_allowed,
        });
      } else this.setState({ isDeliveredItemsAllowed: false });
    } else this.setState({ isDeliveredItemsAllowed: false });

    if (permissions && permissions.length > 0) {
      const loyaltyMembers = permissions.filter((item) => {
        return item.name === "Loyalty Members";
      });
      if (loyaltyMembers && loyaltyMembers.length > 0) {
        this.setState({
          isLoyaltiMembersAllowed: loyaltyMembers[0].is_allowed,
        });
      } else this.setState({ isLoyaltiMembersAllowed: false });
    } else this.setState({ isLoyaltiMembersAllowed: false });

    if (permissions && permissions.length > 0) {
      const orderStagingView = permissions.filter((item) => {
        return item.name === "Order Staging View";
      });
      if (orderStagingView && orderStagingView.length > 0) {
        this.setState({
          isOrderStagingViewAllowed: orderStagingView[0].is_allowed,
        });
      } else this.setState({ isOrderStagingViewAllowed: false });
    } else this.setState({ isOrderStagingViewAllowed: false });

    if (permissions && permissions.length > 0) {
      const consoleReport = permissions.filter((item) => {
        return item.name === "Console Report";
      });
      if (consoleReport && consoleReport.length > 0) {
        this.setState({ isConsoleReportAllowed: consoleReport[0].is_allowed });
      } else this.setState({ isConsoleReportAllowed: false });
    } else this.setState({ isConsoleReportAllowed: false });

    if (permissions && permissions.length > 0) {
      const PatientList = permissions.filter((item) => {
        return item.name === "Patient List" && item.is_allowed === 1;
      });
      if (PatientList && PatientList.length > 0) {
        this.setState({ enrolledPatientsreports: true });
      } else this.setState({ enrolledPatientsreports: false });
    } else this.setState({ enrolledPatientsreports: false });

    if (permissions && permissions.length > 0) {
      const PayrollDeduction = permissions.filter((item) => {
        return item.name === "Payroll Deduction" && item.is_allowed === 1;
      });
      if (PayrollDeduction && PayrollDeduction.length > 0) {
        this.setState({ payrollDeductionsreports: true });
      } else this.setState({ payrollDeductionsreports: false });
    } else this.setState({ payrollDeductionsreports: false });

    if (permissions && permissions.length > 0) {
      const InActiveUsers = permissions.filter((item) => {
        return item.name === "InActive Users" && item.is_allowed === 1;
      });
      if (InActiveUsers && InActiveUsers.length > 0) {
        this.setState({ inActiveUsresAllowed: true });
      } else this.setState({ inActiveUsresAllowed: false });
    } else this.setState({ inActiveUsresAllowed: false });

    if (permissions && permissions.length > 0) {
      const KioskUtilization = permissions.filter((item) => {
        return item.name === "Kiosk Utilization" && item.is_allowed === 1;
      });
      if (KioskUtilization && KioskUtilization.length > 0) {
        this.setState({ kioskUtilizationAllowed: true });
      } else this.setState({ kioskUtilizationAllowed: false });
    } else this.setState({ kioskUtilizationAllowed: false });

    if (permissions && permissions.length > 0) {
      const TemparatureHistory = permissions.filter((item) => {
        return item.name === "Temperature History" && item.is_allowed === 1;
      });
      if (TemparatureHistory && TemparatureHistory.length > 0) {
        this.setState({ tempatureHistoryAllowed: true });
      } else this.setState({ tempatureHistoryAllowed: false });
    } else this.setState({ tempatureHistoryAllowed: false });

    if (permissions && permissions.length > 0) {
      const pmsLogs = permissions.filter((item) => {
        return item.name === "PMS Logs" && item.is_allowed === 1;
      });
      if (
        pmsLogs &&
        pmsLogs.length > 0 &&
        _checkUserRole === USER_ROLES.SUPERADMIN
      ) {
        this.setState({ isPhiLogsVisible: true });
      } else {
        this.setState({ isPhiLogsVisible: false });
      }
    } else {
      this.setState({ isPhiLogsVisible: false });
    }

    if (permissions && permissions.length > 0) {
      const pmsLogs = permissions.filter((item) => {
        return item.name === "Purge trail" && item.is_allowed === 1;
      });
      if (
        pmsLogs &&
        pmsLogs.length > 0 &&
        _checkUserRole === USER_ROLES.SUPERADMIN
      ) {
        this.setState({ isPurgeTrailVisible: true });
      } else {
        this.setState({ isPurgeTrailVisible: false });
      }
    } else {
      this.setState({ isPurgeTrailVisible: false });
    }
    /** Report Permission End Here */
  }
  render() {
    const { classes, t } = this.props;
    const {
      isIpayTransactionAllowed,
      isTemperatureMonitoringAllowed,
      isExpiredItemsAllowed,
      isSurveyReportAllowed,
      isConsultationReportAllowed,
      isScheduleConsultationAllowed,
      isOutForDeliveryAllowed,
      isDeliveredItemsAllowed,
      isLoyaltiMembersAllowed,
      isOrderStagingViewAllowed,
      isConsoleReportAllowed,
      payrollDeductionsreports,
      inActiveUsresAllowed,
      kioskUtilizationAllowed,
      // tempatureHistoryAllowed,
      isPhiLogsVisible,
      isPurgeTrailVisible
    } = this.state;
    const accountConnectionId = sessionStorage.getItem('accountConnectionId');
    return (
      <div id="react-no-print">
        {this.state.Dashboard === true && !this.state.DeliveryTech ?
          (
            <Link to="/home/" style={{ textDecoration: 'none', }}>
              <ListItemButton className={classes.listItem}>
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary={t("Leftbar.Dashboard")} className={classes.textColor} />
              </ListItemButton>
            </Link>
          ) : ('')
        }
        <Divider />
        {
          this.state.assignprescription === true && !this.state.DeliveryTech ? (
            this.props.isVisible && this.props.isVisible === true ? (
              <Link to="/home/prescription/unpluggedassign" style={{ textDecoration: 'none' }}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <AssignPrescriptionIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Leftbar.DeliverPrescription")} className={classes.textColor} />
                </ListItemButton>
              </Link>
            ) : (
              <Link to="/home/prescription/assign" style={{ textDecoration: 'none' }}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <AssignPrescriptionIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Leftbar.DeliverPrescription")} className={classes.textColor} />
                </ListItemButton>
              </Link>
            )
          ) : ('')
        }

        {this.state.reports === true && !this.state.DeliveryTech ? (
          <React.Fragment>
            <ListItemButton
              onClick={this.handleClick}
              className={classes.listItem}
            >
              <ListItemIcon>
                <ReportsIcon />
              </ListItemIcon>
              <ListItemText
                inset
                primary={t("Leftbar.Report")}
                className={classes.textColor}
                style={{ paddingLeft: "0px" }}
              />
              {this.state.open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
              {this.state.assigneditemsreports === true ? (
                <Link
                  to="/home/reports/assigned-items/assigneditems"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.AssignedItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.stockeditemsreports === true ? (
                <Link
                  to="/home/reports/stock-list/StockLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.StockedItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.pickedUpitemsreports === true ? (
                <Link
                  to="/home/reports/pickup/PickUpLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PickupItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.cancelledItemsReports === true && (
                <Link
                  to="/home/reports/cancelled-list/CancelledLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.CancelledItemsReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {this.state.transactionsreports === true ? (
                <Link
                  to="/home/reports/transaction/TransactionLists"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.TransactionsReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {this.state.enrolledPatientsreports === true ? (
                <Link
                  to="/home/reports/enrolled-patients/enrolledpatients"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PatientListReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {payrollDeductionsreports && (
                <Link
                  to="/home/reports/payroll-deductions/payrollDeductions"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PayrollDeductionReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {isExpiredItemsAllowed ? (
                <Link
                  to="/home/reports/expired-items/expireditems"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ExpireItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isSurveyReportAllowed ? (
                <Link
                  to="/home/reports/survey-report/surveyreport"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.SurveyItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isConsultationReportAllowed ? (
                <Link
                  to="/home/reports/consultation/consultreport"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ConsultationReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isScheduleConsultationAllowed ? (
                <Link
                  to="/home/reports/consultation/scheduleconsultreport"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ScheduleReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isOutForDeliveryAllowed ? (
                <Link
                  to="/home/reports/out-of-delivery/delivery"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.OutForDeliveryReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isDeliveredItemsAllowed ? (
                <Link
                  to="/home/reports/my-delivery/delivery"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.DeliveredItemReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isIpayTransactionAllowed ? (
                <Link
                  to="/home/reports/transaction/ipaytransactions"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.iPayReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {isTemperatureMonitoringAllowed ? (
                <Link
                  to="/home/reports/temperaturemonitoring"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.TemperatureReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : (
                ""
              )}
              {isLoyaltiMembersAllowed ? (
                <Link
                  to="/home/reports/enrolled-loyalty-members"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.LoyaltyReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}

              {isOrderStagingViewAllowed ? (
                <Link
                  to="/home/reports/orders-view"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.OrderStagingReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {isConsoleReportAllowed ? (
                <Link
                  to="/home/reports/console-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.ConsoleReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {inActiveUsresAllowed && (
                <Link
                  to="/home/reports/inactive-users-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.InactiveUserReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {kioskUtilizationAllowed && (
                <Link
                  to="/home/reports/kiosk-utilization"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.KioskUtilReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              )}
              {/* { tempatureHistoryAllowed && (
               <Link to="/home/reports/temp-report" style={{ textDecoration: 'none' }}>
                <List component="div" disablePadding>
                  <ListItemButton className={classes.listItem}>
                     <ListItemText inset primary={t("Leftbar.TemperatureHistoryReport")} className={classes.textColor}/>
                  </ListItemButton>
                </List>
               </Link>
              )} */}
              {isPhiLogsVisible ? (
                <Link
                  to="/home/reports/phi-logs"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PhiLogs")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              {accountConnectionId === connectionType.THIRD_PARTY ? (
                <Link
                  to="/home/reports/vendor-orders"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.VendorOrdersReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
              <Link
                  to="/home/reports/audit-trail"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.AuditReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
                <Link
                  to="/home/reports/pop-quiz"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Leftbar.PopQuizReport")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              {isPurgeTrailVisible ? (
                <Link
                  to="/home/reports/purge-trail-report"
                  style={{ textDecoration: "none" }}
                >
                  <List component="div" disablePadding>
                    <ListItemButton className={classes.listItem}>
                      <ListItemText
                        inset
                        primary={t("Report.purgeTrail.ReportTitle")}
                        className={classes.textColor}
                      />
                    </ListItemButton>
                  </List>
                </Link>
              ) : null}
            </Collapse>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    );
  }
}

NestedList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(NestedList));



// WEBPACK FOOTER //
// ./src/components/leftnav/reportlink.js